import React from 'react';
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

/**
 * MathText
 * Renders text that may contain inline math wrapped in $...$ or block math wrapped in $$...$$.
 * Non-math segments are rendered as plain text; math segments render via KaTeX.
 *
 * Props:
 *   children: string | undefined — the text to render
 *   className: optional className applied to the wrapping <span>
 */
const MATH_RE = /(\$\$[^$]+?\$\$|\$[^$\n]+?\$)/g;

export const MathText = ({ children, className = '' }) => {
  const text = children == null ? '' : String(children);
  if (!text) return null;
  if (!text.includes('$')) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(MATH_RE);
  return (
    <span className={className}>
      {parts.map((part, idx) => {
        if (!part) return null;
        if (part.startsWith('$$') && part.endsWith('$$')) {
          const inner = part.slice(2, -2);
          try {
            return <BlockMath key={idx} math={inner} />;
          } catch {
            return <span key={idx}>{part}</span>;
          }
        }
        if (part.startsWith('$') && part.endsWith('$')) {
          const inner = part.slice(1, -1);
          try {
            return <InlineMath key={idx} math={inner} />;
          } catch {
            return <span key={idx}>{part}</span>;
          }
        }
        return <span key={idx}>{part}</span>;
      })}
    </span>
  );
};

export default MathText;
